import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getMedia,
  getMediaPresentationStyle,
  getPrimaryMediaType,
  renderCaption,
  renderDek,
} from 'lib/articleUtils';
import { articleChildContextTypes } from 'lib/ContextTypes/article';
import {
  video as videoPropType,
  socialMediaProfiles as socialPropType,
} from 'lib/CustomPropTypes';
import Breakpoints from 'lib/Breakpoints';

import ShowBlogHeroHeadline from './ShowBlogHeroHeadline';

import './styles.themed.scss';

const block = 'showBlog-hero';

const mapStateToProps = ({ shared }) => ({
  socialMediaProfiles: shared.socialMediaProfiles,
});

class ShowBlogHero extends Component {
  static propTypes = {
    // this needs a new custom proptype called primaryMedia that can accept image/vid or null
    content: videoPropType.isRequired,
    gridBodyClasses: PropTypes.string,
    headlineClassName: PropTypes.arrayOf(PropTypes.string),
    isChromeless: PropTypes.bool,
    path: PropTypes.string,
    socialMediaProfiles: socialPropType.isRequired,
    vertical: PropTypes.string.isRequired,
  };

  static childContextTypes = articleChildContextTypes;

  static defaultProps = {
    gridBodyClasses: '',
    headlineClassName: [],
    isChromeless: false,
    path: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      hasStickyVideo: false,
      isVideoPlaying: false,
      isMobile: false,
    };
  }

  componentDidMount() {
    this.setState({ isMobile: Breakpoints.isSorM() });
  }

  setVideoPlayState = () => {
    this.setState({ isVideoPlaying: true });
  }

  setStickyVideoFlag = (hasStickyVideo) => {
    this.setState({ hasStickyVideo });
  }

  getChildContext = () => {
    const {
      vertical,
      content,
      socialMediaProfiles,
      isChromeless,
    } = this.props;

    const {
      hasStickyVideo,
      isVideoPlaying,
      isMobile,
    } = this.state;

    return {
      content,
      block,
      hasStickyVideo,
      isChromeless,
      isMobile,
      isVideoPlaying,
      socialMediaProfiles,
      vertical,
      isShowBlog: true,
      setStickyVideoFlag: this.setStickyVideoFlag,
      setVideoPlayState: this.setVideoPlayState,
    };
  }

  checkABTestingFeature = (feature) => {
    const { autoplayTestGroup } = this.state;
    return autoplayTestGroup === feature;
  };

  render() {
    const {
      content: {
        headline,
      },
      gridBodyClasses,
      headlineClassName,
      path,
      vertical,
    } = this.props;

    const {
      hasStickyVideo,
    } = this.state;

    const mediaPresentationStyle = getMediaPresentationStyle(this.getChildContext());
    const mediaType = getPrimaryMediaType(this.getChildContext());
    const media = getMedia(this.getChildContext());

    const containerClasses = classNames(
      `${block}__container`,
      'layout-grid-container',
      [mediaPresentationStyle],
      {
        [`${block}__sticky-video`]: hasStickyVideo,
      },
    );

    return (
      <section
        className={containerClasses}
        data-test={block}
        data-testid={block}
      >
        <div
          className={classNames(
            gridBodyClasses,
            'showBlog-hero__subcontainer',
          )}
        >
          <div
            className={classNames(
              `${block}__media-holder`,
              {
                mb7: mediaType === null || mediaType === 'image',
                'mb5 mb5-m': mediaType === 'video',
              },
            )}
            data-testid={`${block}__media-holder`}
          >
            {media && (
              <div
                className={classNames(
                  `${block}__media-container`,
                )}
              >
                {media}
              </div>
            )}
            {renderCaption(this.getChildContext())}
          </div>
          <header
            className={classNames(
              `${block}__header`,
              'mh0-print',
            )}
            data-test={`${block}__header`}
            data-testid={`${block}__header`}
          >
            <ShowBlogHeroHeadline
              className={classNames(
                `${block}__headline`,
                headlineClassName,
              )}
              dek={renderDek(this.getChildContext())}
              path={path}
              vertical={vertical}
            >
              {headline.primary}
            </ShowBlogHeroHeadline>
          </header>
        </div>
      </section>
    );
  }
}

export default connect(mapStateToProps)(ShowBlogHero);
